import React from "react";
import "./Contact.css";

const Contact = () => {
  return (
    <section className="contact container section" id="contact">
      <h2 className="section__title">Get In Touch</h2>

      <div className="contact__container grid">
        <div className="contact__info">
          <h3 className="contact__title">Let's talk about everything!</h3>
          <p className="contact__details">
            Don't like forms? Send me an email.    <br />   khandakeratik43@gmail.com 👋
          </p>
        </div>

        <form
          action="https://formsubmit.co/khandakeratik43@gmail.com"
          method="POST"
          className="contact__form"
        >
          <div className="contact__form-group">
            <div className="contact__form-div">
              <input
                type="text"
                name="name"
                className="contact__form-input"
                placeholder="Your Name"
                required
              />
            </div>

            <div className="contact__form-div">
              <input
                type="number"
                name="phone"
                className="contact__form-input"
                placeholder="Phone Number"
              />
            </div>

            <div className="contact__form-div">
              <input
                type="email"
                name="email"
                className="contact__form-input"
                placeholder="Your Email"
                required
              />
            </div>
          </div>

          <div className="contact__form-div contact__form-area">
            <textarea
              name="message"
              className="contact__form-input"
              placeholder="Write your message"
              rows="10"
              required
            ></textarea>
          </div>

          <button type="submit" className="btn">
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
